var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2["BAD_REQUEST"] = "BAD_REQUEST";
  ErrorCode2["UNAUTHORIZED"] = "UNAUTHORIZED";
  ErrorCode2["FORBIDDEN"] = "FORBIDDEN";
  ErrorCode2["NOT_FOUND"] = "NOT_FOUND";
  ErrorCode2["CONFLICT"] = "CONFLICT";
  ErrorCode2["VALIDATION_ERROR"] = "VALIDATION_ERROR";
  ErrorCode2["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
  ErrorCode2["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
  ErrorCode2["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
  return ErrorCode2;
})(ErrorCode || {});
function createSuccessResponse(data) {
  return { success: true, data };
}
function createErrorResponse(code, message, details) {
  return {
    success: false,
    error: {
      code,
      message,
      ...details !== void 0 && { details }
    }
  };
}
function isPaginatedResponse(response) {
  if (response === null || response === void 0) {
    return false;
  }
  if (typeof response !== "object") {
    return false;
  }
  const obj = response;
  return Array.isArray(obj["data"]) && typeof obj["total"] === "number" && typeof obj["page"] === "number" && typeof obj["pageSize"] === "number" && typeof obj["hasMore"] === "boolean";
}
export {
  ErrorCode,
  createErrorResponse,
  createSuccessResponse,
  isPaginatedResponse
};
//# sourceMappingURL=api.js.map